module.exports = __webpack_public_path__ + "img/shidu-1.png";